import React, { Fragment, useEffect } from 'react'
import { withResizeDetector } from 'react-resize-detector'

import './vendor/bootstrap-select/dist/css/bootstrap-select.min.css'
import './css/style.css'
import './index.css'

import Routes from './Routes/index'
import { getAuth, onAuthStateChanged, signInAnonymously } from '@firebase/auth'
import { initializeApp } from '@firebase/app'
import config from './config'
import { useGetWebConfigQuery } from './services/webConfigApi'
import { useDispatch } from 'react-redux'
import { setWebConfig } from './reducers/webconfig/webConfigSlice'
initializeApp(config.firebase)
const auth = getAuth()
signInAnonymously(auth)
  .then(() => {
    console.log('Permissions Success')
  })
  .catch((err) => console.log(err))
onAuthStateChanged(auth, (user) => {
  if (user) {
    console.log('login success')
  } else {
    console.log('logout')
  }
})

const App = ({ width }) => {
  // const history = useHistory();
  const dispatch = useDispatch()
  const { data, isSuccess } = useGetWebConfigQuery()
  const body = document.querySelector('body')
  body.setAttribute('data-typography', 'poppins')
  body.setAttribute('data-theme-version', 'light')
  body.setAttribute('data-layout', 'vertical')
  body.setAttribute('data-nav-headerbg', 'color_1')
  body.setAttribute('data-headerbg', 'color_1')
  body.setAttribute('data-sidebar-style', 'compact')
  body.setAttribute('data-sibebarbg', 'color_1')
  body.setAttribute('data-primary', 'color_1')
  body.setAttribute('data-sidebar-position', 'fixed')
  body.setAttribute('data-header-position', 'fixed')
  body.setAttribute('data-container', 'wide')
  body.setAttribute('direction', 'ltr')

  useEffect(() => {
    if (isSuccess) dispatch(setWebConfig(data))
  }, [data, isSuccess, dispatch])

  width >= 768 && width < 1300
    ? body.setAttribute('data-sidebar-style', 'mini')
    : width <= 768
    ? body.setAttribute('data-sidebar-style', 'overlay')
    : body.setAttribute('data-sidebar-style', 'full')

  return (
    <Fragment>
      <Routes />
    </Fragment>
  )
}

export default withResizeDetector(App)
